const pad = (n) => String(n).padStart(2, "0");

// UTC compact format: YYYYMMDDTHHMMSSZ
const toStamp = (d) =>
  `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

// ISO with seconds for Outlook/Office365
const toIso = (d) => d.toISOString().replace(/\.\d{3}Z$/, "Z");

export const buildCalendarLinks = ({ title, start, end, location, description }) => {
  const dtStart = new Date(start);
  const dtEnd = end ? new Date(end) : new Date(dtStart.getTime() + 2 * 3600 * 1000);
  const t = title || "Event";
  const loc = location || "";
  const desc = description || "";

  const google =
    "https://calendar.google.com/calendar/render?action=TEMPLATE" +
    `&text=${encodeURIComponent(t)}` +
    `&dates=${toStamp(dtStart)}/${toStamp(dtEnd)}` +
    `&details=${encodeURIComponent(desc)}` +
    `&location=${encodeURIComponent(loc)}`;

  const outlookParams =
    "path=/calendar/action/compose&rru=addevent" +
    `&subject=${encodeURIComponent(t)}` +
    `&startdt=${encodeURIComponent(toIso(dtStart))}` +
    `&enddt=${encodeURIComponent(toIso(dtEnd))}` +
    `&body=${encodeURIComponent(desc)}` +
    `&location=${encodeURIComponent(loc)}`;

  const outlook = `https://outlook.live.com/calendar/0/deeplink/compose?${outlookParams}`;
  const office365 = `https://outlook.office.com/calendar/0/deeplink/compose?${outlookParams}`;

  const yahoo =
    "https://calendar.yahoo.com/?v=60" +
    `&title=${encodeURIComponent(t)}` +
    `&st=${toStamp(dtStart)}` +
    `&et=${toStamp(dtEnd)}` +
    `&desc=${encodeURIComponent(desc)}` +
    `&in_loc=${encodeURIComponent(loc)}`;

  return { google, outlook, office365, yahoo };
};
